import { isLocaleRegionIsUK } from './regionUtils';

/**
 * Returns the appropriate deductible text based on locale.
 * In UK regions, returns "Excess", otherwise "Deductible".
 *
 * @returns The localized deductible text
 */
export const getDeductibleText = (): string => {
  return isLocaleRegionIsUK() ? 'Excess' : 'Deductible';
};
